import { render, staticRenderFns } from "./ShipmentDetailRemark.vue?vue&type=template&id=3d8bb4e1&"
import script from "./ShipmentDetailRemark.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports